module.exports = __webpack_public_path__ + "media/packs/images/flags/CK-9ce1b30ef1832d9f1e07cc7c400006ca.png";